import {COMP_FIELDS, CompFieldValue} from '@/constants/comp';
import {AccountInvestments} from '@/types/client-info';

export type FundKeyFields = {fundCode: string; certificateNo?: string};

export const COMP_TO_INVESTMENT_MAPPINGS: {
  compKeyField: CompFieldValue;
  investmentType: keyof AccountInvestments;
  getFreshInvestments: (investments: AccountInvestments | null) => FundKeyFields[];
  getKey: (item: FundKeyFields) => string;
}[] = [
  {
    compKeyField: COMP_FIELDS.COMP8_benevaGuaranteedInvestmentFundCode,
    investmentType: 'benevaGuaranteedInvestmentFunds',
    getFreshInvestments: investments => investments?.benevaGuaranteedInvestmentFunds ?? [],
    getKey: item => item.fundCode,
  },
  {
    compKeyField: COMP_FIELDS.COMP13_benevaInvestmentAccountFundCode,
    investmentType: 'benevaInvestmentAccounts',
    getFreshInvestments: investments => investments?.benevaInvestmentAccounts ?? [],
    getKey: item => item.fundCode,
  },
  {
    compKeyField: COMP_FIELDS.COMP18_dailyInterestAccountFundCode,
    investmentType: 'dailyInterestAccounts',
    getFreshInvestments: investments => investments?.dailyInterestAccounts ?? [],
    getKey: item => item.fundCode,
  },
  {
    compKeyField: COMP_FIELDS.COMP21_highYieldAccountFundCode,
    investmentType: 'highYieldAccounts',
    getFreshInvestments: investments => investments?.highYieldAccounts ?? [],
    getKey: item => item.fundCode,
  },
  {
    compKeyField: COMP_FIELDS.COMP25_guaranteedInterestAccountCertificateNo,
    investmentType: 'benevaGuaranteedInterestAccounts',
    getFreshInvestments: investments => investments?.benevaGuaranteedInterestAccounts ?? [],
    getKey: item => item.certificateNo ?? item.fundCode,
  },
];
